import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/mobile',
    name: 'MobileIndex',
    component: () => import('../views/mobile/index.vue'),
    meta: { title: '医院感染管理系统' }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: '登录' }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true ,title:'首页'},
    children: [
      // 数据录入相关路由
      {
        path: 'mdro-detection',
        name: 'MdroDetection',
        component: () => import('../views/form/MdroDetection.vue'),
        meta: { title: '全院多重耐药菌检出情况' }
      },
      {
        path: 'mdro-infection',
        name: 'MdroInfection',
        component: () => import('../views/form/MdroInfection.vue'),
        meta: { title: '全院多重耐药菌感染情况' }
      },
      {
        path: 'mdro-isolation',
        name: 'MdroIsolation',
        component: () => import('../views/form/MdroIsolation.vue'),
        meta: { title: 'MDRO患者接触隔离医嘱开具情况' }
      },
      {
        path: 'mdro-department',
        name: 'MdroDepartment',
        component: () => import('../views/form/MdroDepartment.vue'),
        meta: { title: 'MDRO各科室检出例数汇总' }
      },
      {
        path: 'target-monitoring',
        name: 'TargetMonitoring',
        component: () => import('../views/form/TargetMonitoring.vue'),
        meta: { title: '目标性监测' }
      },
      {
        path: 'surgery',
        name: 'Surgery',
        component: () => import('../views/form/Surgery.vue'),
        meta: { title: '手术部位感染' }
      },
      
      // 数据统计相关路由
      {
        path: 'infection-statistic',
        name: 'InfectionStatistic',
        component: () => import('../views/statistic/InfectionStatistic.vue'),
        meta: { title: '医院感染率统计' }
      },
      {
        path: 'mdro-statistic',
        name: 'MdroStatistic',
        component: () => import('../views/statistic/MdroStatistic.vue'),
        meta: { title: '多重耐药菌统计' }
      },
      {
        path: 'target-statistic',
        name: 'TargetStatistic',
        component: () => import('../views/statistic/TargetStatistic.vue'),
        meta: { title: '目标性监测统计' }
      },
      {
        path: 'surgery-statistic',
        name: 'SurgeryStatistic',
        component: () => import('../views/statistic/SurgeryStatistic.vue'),
        meta: { title: '手术部位感染统计' }
      },
      {
        path: 'icusg-statistic',
        name: 'IcusgStatistic',
        component: () => import('../views/statistic/IcusgStatistic.vue'),
        meta: { title: 'ICU“三管”相关感染监测' }
      },
      {
        path: 'nicu-statistic',
        name: 'NicuStatistic',
        component: () => import('../views/statistic/NicuStatistic.vue'),
        meta: { title: 'NICU医院感染监测' }
      },
      {
        path: 'eicu-statistic',
        name: 'EicuStatistic',
        component: () => import('../views/statistic/EicuStatistic.vue'),
        meta: { title: 'NICU医院感染监测' }
      },
      {
        path: 'surgeryTarget-statistic',
        name: 'SurgeryTargetStatistic',
        component: () => import('../views/statistic/SurgeryTargetStatistic.vue'),
        meta: { title: '手术部位感染目标性监测' }
      },
      {
        path: 'hospital-three-tube-monitor',
        name: 'HospitalThreeTubeMonitor',
        component: () => import('../views/statistic/HospitalThreeTubeMonitor.vue'),
        meta: { title: '全院三管相关感染监测' }
      },
      {
        path: 'blood-infection-monitor',
        name: 'BloodInfectionMonitor',
        component: () => import('../views/statistic/BloodInfectionMonitor.vue'),
        meta: { title: '血液感染监测' }
      },
      {
        path: 'hand-hygiene-compliance-statistic',
        name: 'HandHygieneComplianceStatistic',
        component: () => import('../views/statistic/HandHygieneComplianceStatistic.vue'),
        meta: { title: '手卫生依从性统计' }
      },
      {
        path: 'hand-hygiene-form1',
        name: 'HandHygieneForm1',
        component: () => import('../views/statistic/HandHygieneForm1.vue'),
        meta: { title: '手卫生操作考核评分表1(洗手与卫生手消毒)' }
      },
      {
        path: 'hand-hygiene-form3',
        name: 'HandHygieneForm3',
        component: () => import('../views/statistic/HandHygieneForm3.vue'),
        meta: { title: '手卫生操作考核评分表2(外科手消毒)' }
      },
      {
        path: 'hand-hygiene1',
        name: 'HandHygiene1',
        component: () => import('../views/statistic/HandHygiene1.vue'),
        meta: { title: '手卫生依从性调查表' }
      },
      {
        path: 'ISurgery',
        name: 'ISurgery',
        component: () => import('../views/statistic/ISurgery.vue'),
        meta: { title: 'I类切口手术部位感染及预防性抗菌药物使用情况' }
      },
      {
        path: 'antibacterialDrugs',
        name: 'AntibacterialDrugs',
        component: () => import('../views/statistic/AntibacterialDrugs.vue'),
        meta: { title: '抗菌药物使用情况' }
      },
      // 数据分析相关路由
      {
        path: '/analysis/infection',
        name: 'infectionAnalysis',
        component: () => import('../views/analysis/Infection.vue'),
        meta: { requiresAuth: true ,title:'感染率统计分析'}
      },
      {
        path: '/analysis/mdro',
        name: 'mdroAnalysis',
        component: () => import('../views/analysis/Mdro.vue'),
        meta: { requiresAuth: true ,title:'MDRO统计分析'}
      },
      {
        path: '/analysis/monitor',
        name: 'monitorAnalysis',
        component: () => import('../views/analysis/Monitor.vue'),
        meta: { requiresAuth: true ,title:'全院三管感染率统计分析'}
      },
      {
        path: '/analysis/antibiotics',
        name: 'antibioticsAnalysis',
        component: () => import('../views/analysis/Antibiotics.vue'),
        meta: { requiresAuth: true ,title:'抗菌药物统计分析'}
      },
      {
        path: '/analysis/surgery',
        name: 'surgeryAnalysis',
        component: () => import('../views/analysis/OneSurgery.vue'),
        meta: { requiresAuth: true ,title:'手术部位感染统计分析'}
      },
      {
        path: '/analysis/handHygiene',
        name: 'handHygieneAnalysis',
        component: () => import('../views/analysis/HandHygiene.vue'),
        meta: { requiresAuth: true ,title:'手卫生统计分析'}
      },
      
      
      // 预警相关路由
      {
        path: '/alert/rules',
        name: 'alertRules',
        component: () => import('../views/alert/Rules.vue'),
        meta: { requiresAuth: true ,title:'预警规则'}
      },
      {
        path: '/alert/records',
        name: 'alertRecords',
        component: () => import('../views/alert/Records.vue'),
        meta: { requiresAuth: true ,title:'预警记录'}
      },
      {
        path: '/alert/follow',
        name: 'alertFollow',
        component: () => import('../views/alert/Follow.vue'),
        meta: { requiresAuth: true ,title:'预警关注'}
      },
      
      // 督查相关路由
      {
        path: '/supervision/tasks',
        name: 'supervisionTasks',
        component: () => import('../views/supervision/Tasks.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/supervision/records',
        name: 'supervisionRecords',
        component: () => import('../views/supervision/Records.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/supervision/implement',
        name: 'supervisionImplement',
        component: () => import('../views/supervision/Implement.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/supervision/InfectionControlInspectiors',
        name: 'supervisionInfectionControlInspectiors',
        component: () => import('../views/supervision/InfectionControlInspectiors.vue'),
        meta: { requiresAuth: true ,title:'感染管理质控督察'}
      }
    ]
  },
  
  // 手卫生考核相关路由（独立路由，不需要认证）
  {
    path: '/handHygieneForm',
    name: 'HandHygieneForm',
    component: () => import('../views/mobile/HandHygieneForm1/HandHygieneForm.vue'),
    meta: { title: '手卫生操作考核表' }
  },
  {
    path: '/handHygieneAssessment',
    name: 'HandHygieneAssessment',
    component: () => import('../views/mobile/HandHygieneForm1/HandHygieneAssessment.vue'),
    meta: { title: '手卫生操作考核' }
  },
  {
    path: '/handHygieneAssessmentStep2',
    name: 'HandHygieneAssessmentStep2',
    component: () => import('../views/mobile/HandHygieneForm1/HandHygieneAssessmentStep2.vue'),
    meta: { title: '手卫生操作考核' }
  },
  {
    path: '/handHygieneAssessmentStep3',
    name: 'HandHygieneAssessmentStep3',
    component: () => import('../views/mobile/HandHygieneForm1/HandHygieneAssessmentStep3.vue'),
    meta: { title: '手卫生操作考核' }
  },
  {
    path: '/handHygieneAssessmentResult',
    name: 'HandHygieneAssessmentResult',
    component: () => import('../views/mobile/HandHygieneForm1/HandHygieneAssessmentResult.vue'),
    meta: { title: '手卫生操作考核结果' }
  },
   // 手卫生考核相关路由（独立路由，不需要认证）
   {
    path: '/handHygieneForm2',
    name: 'HandHygieneForm2',
    component: () => import('../views/mobile/HandHygieneForm2/HandHygieneForm.vue'),
    meta: { title: '手卫生操作考核表' }
  },
  {
    path: '/handHygieneAssessment2',
    name: 'HandHygieneAssessment2',
    component: () => import('../views/mobile/HandHygieneForm2/HandHygieneAssessment.vue'),
    meta: { title: '手卫生操作考核' }
  },
  {
    path: '/handHygieneAssessmentStep22',
    name: 'HandHygieneAssessmentStep22',
    component: () => import('../views/mobile/HandHygieneForm2/HandHygieneAssessmentStep2.vue'),
    meta: { title: '手卫生操作考核' }
  },
  {
    path: '/handHygieneAssessmentStep32',
    name: 'HandHygieneAssessmentStep32',
    component: () => import('../views/mobile/HandHygieneForm2/HandHygieneAssessmentStep3.vue'),
    meta: { title: '手卫生操作考核' }
  },
  {
    path: '/handHygieneAssessmentResult2',
    name: 'HandHygieneAssessmentResult2',
    component: () => import('../views/mobile/HandHygieneForm2/HandHygieneAssessmentResult.vue'),
    meta: { title: '手卫生操作考核结果' }
  },
  // 手卫生依从性调查表
  {
    path: '/handHygiene',
    name: 'HandHygiene',
    component: () => import('../views/mobile/HandHygiene/HandHygiene.vue'),
    meta: { title: '手卫生依从性调查表' }
  },
  {
    path: '/handHygieneSurvey',
    name: 'HandHygieneSurvey',
    component: () => import('../views/mobile/HandHygiene/HandHygieneSurvey.vue'),
    meta: { title: '手卫生依从性调查表' }
  },
  // 感染管理质控督查表(病区)
  {
    path: '/infectionManagement',
    name: 'InfectionManagement',
    component: () => import('../views/mobile/InfectionManagement/InfectionManagement.vue'),
    meta: { title: '感染管理质控督查表(病区)' }
  },
  {
    path: '/infectionManagementSurvey',
    name: 'InfectionManagementSurvey',
    component: () => import('../views/mobile/InfectionManagement/InfectionManagementSurvey.vue'),
    meta: { title: '感染管理质控督查表(病区)' }
  },
  {
    path: '/infectionManagementParts',
    name: 'InfectionManagementParts',
    component: () => import('../views/mobile/InfectionManagement/InfectionManagementParts.vue'),
    meta: { title: '感染管理部件' }
  },
  {
    path: '/infectionManagementInvade',
    name: 'InfectionManagementInvade',
    component: () => import('../views/mobile/InfectionManagement/InfectionManagementInvade.vue'),
    meta: { title: '侵入性操作感染管理' }
  },
  {
    path: '/infectionManagementInfect',
    name: 'InfectionManagementInfect',
    component: () => import('../views/mobile/InfectionManagement/InfectionManagementInfect.vue'),
    meta: { title: '感染监测管理' }
  },
  {
    path: '/infectionManagementHand',
    name: 'InfectionManagementHand',
    component: () => import('../views/mobile/InfectionManagement/InfectionManagementHand.vue'),
    meta: { title: '手部感染管理' }
  },
  {
    path: '/mdroForm',
    name: 'MdroForm',
    component: () => import('../views/mobile/Mdro/MdroForm.vue'),
    meta: { title: '传染病/多重耐药菌患者防控措施落实督查表' }
  },
  {
    path: '/mobile/surgeryInfection',
    name: 'SurgeryInfection',
    component: () => import('../views/mobile/SurgeryInfection/SurgeryInfectionForm.vue'),
    meta: { title: '手术部位感染防控核查表单' }
  },
  {
    path: '/mobile/PICC',
    name: 'PICC',
    component: () => import('../views/mobile/PICC.vue'),
    meta: { title: 'PICC穿刺检查' }
  },
  {
    path: '/mobile/UrinaryCatheter',
    name: 'UrinaryCatheter',
    component: () => import('../views/mobile/UrinaryCatheter.vue'),
    meta: { title: '导尿管日常维护核查表' }
  },
  {
    path: '/mobile/UrinaryCatheterInsert',
    name: 'UrinaryCatheterInsert',
    component: () => import('../views/mobile/UrinaryCatheterInsertion.vue'),
    meta: { title: '导尿管置入核查表' }
  },
  {
    path: '/mobile/ventilatorPneumonia',
    name: 'VentilatorPneumonia',
    component: () => import('../views/mobile/VentilatorPneumonia.vue'),
    meta: { title: '呼吸机相关性肺炎预防与控制措施核查表' }
  },
  {
    path: '/mobile/CVCPICC',
    name: 'CVCPICC',
    component: () => import('../views/mobile/CVCPICCMaintenance.vue'),
    meta: { title: 'CVCPICC维护核查表' }
  },
  {
    path: '/mobile/CVC',
    name: 'CVC',
    component: () => import('../views/mobile/CVC.vue'),
    meta: { title: 'CVC维护核查表' }
  },
  {
    path: '/mobile/test-api',
    name: 'TestAPI',
    component: () => import('../views/mobile/test-api.vue'),
    meta: { title: 'API连接测试' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  
  // 动态设置页面标题
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = '医院感染管理系统' // 默认标题
  }
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
